<template>
    <v-container fluid>
        <v-row
            align="center"
            no-gutters
        >
            <v-col
                cols="12"
                justify="center"
                sm="8"
            >
                <v-subheader>
                    <h2>Medikredit-Claims ({{ totalMatches }})</h2>
                </v-subheader>
            </v-col>
        </v-row>
        <v-container class="pb-10">
            <v-row
                justify="center"
                v-if="medikreditclaimsReducedView === null"
            >
                <v-col
                    :key="i"
                    cols="12"
                    v-for="i in 6"
                >
                    <v-skeleton-loader
                        elevation="4"
                        type="card"
                    ></v-skeleton-loader>
                </v-col>
            </v-row>
            <v-row
                justify="center"
                v-else
            >
                <v-col
                    :key="medikreditclaimReducedView.id"
                    cols="12"
                    v-for="medikreditclaimReducedView in medikreditclaimsReducedView"
                >
                    <v-card
                        @click="loadMedikreditClaimForm(medikreditclaimReducedView)"
                        class="incident-card fill-height"
                        elevation="4"
                        style="overflow: hidden"
                    >
                        <v-card-title style="cursor: pointer">
                            #{{ medikreditclaimReducedView.id }}
                            <v-chip
                                class="ml-3"
                                color="secondary"
                                dark
                                small
                            >
                                <v-icon
                                    left
                                    small
                                >mdi-file</v-icon>
                                File: {{filenameRegex.exec(medikreditclaimReducedView.medikreditClaimCsvName)[0]}}
                            </v-chip>
                        </v-card-title>

                        <v-card-text class="center-content pa-1">
                            <v-row justify="space-around">
                                <v-col
                                    cols="6"
                                    lg="3"
                                    md="4"
                                    xl="2"
                                >
                                    <v-card class="pa-2 ma-2">
                                        Patient Found:
                                        <v-icon
                                            color="success"
                                            v-if="medikreditclaimReducedView.hasPatient"
                                        >mdi-check</v-icon>
                                        <v-icon
                                            color="error"
                                            v-else
                                        >mdi-close</v-icon>
                                        <br />
                                        Name: {{medikreditclaimReducedView.patientName}}
                                        <br />
                                        Surname: {{medikreditclaimReducedView.patientSurname}}
                                        <br />
                                        Identity Number: {{medikreditclaimReducedView.patientIdentityNumber}}
                                        <br />
                                        <span v-show="medikreditclaimReducedView.hasPatient">Member Id: {{medikreditclaimReducedView.patientId}}</span>
                                    </v-card>
                                </v-col>

                                <v-col
                                    cols="6"
                                    lg="3"
                                    md="4"
                                    xl="2"
                                >
                                    <v-card class="pa-2 ma-2">
                                        Incident Found:
                                        <v-icon
                                            color="success"
                                            v-if="medikreditclaimReducedView.incidentId > 0"
                                        >mdi-check</v-icon>
                                        <v-icon
                                            color="error"
                                            v-else
                                        >mdi-close</v-icon>
                                        <br />
                                        <span v-if="medikreditclaimReducedView.incidentId > 0">Incident #{{medikreditclaimReducedView.incidentId}}</span>
                                    </v-card>
                                    <v-card class="pa-2 ma-2">
                                        Provider Found:
                                        <v-icon
                                            color="success"
                                            v-if="medikreditclaimReducedView.hasProvider"
                                        >mdi-check</v-icon>
                                        <v-icon
                                            color="error"
                                            v-else
                                        >mdi-close</v-icon>
                                        <br />
                                        Bhf Number: {{medikreditclaimReducedView.providerBhf}}
                                    </v-card>
                                </v-col>

                                <v-col
                                    cols="6"
                                    lg="3"
                                    md="4"
                                    xl="2"
                                >
                                    <v-card
                                        @click.stop="$router.push({ name: 'Accounts', params: { accountId: medikreditclaimReducedView.accountId }})"
                                        class="pa-2 ma-2"
                                        v-if="medikreditclaimReducedView.accountId > 0"
                                    >
                                        Account Created:
                                        <v-icon
                                            color="success"
                                            v-if="medikreditclaimReducedView.hasPatient"
                                        >mdi-check</v-icon>
                                        <div>Account #{{medikreditclaimReducedView.accountId}}</div>
                                    </v-card>
                                    <v-card
                                        class="pa-2 ma-2"
                                        v-else
                                    >
                                        Account Created:
                                        <v-icon color="error">mdi-close</v-icon>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <!--EDIT FORM SECTION-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-->
        <v-dialog
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
            v-model="medikreditclaimFormVisible"
        >
            <v-sheet
                class="base-background"
                min-height="100%"
            >
                <v-toolbar
                    color="secondary darken-1"
                    dark
                >
                    <v-btn
                        @click="closeMedikreditClaimForm"
                        dark
                        icon
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Medikredit-Claim Details</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-container>
                    <MedikreditClaimForm
                        :key="medikreditclaimFormId"
                        :medikreditclaimid="medikreditclaimFormId"
                        @close="closeMedikreditClaimForm"
                        @deleted="deleteMedikreditClaim"
                        @saved="updateMedikreditClaim"
                    />
                </v-container>
            </v-sheet>
        </v-dialog>
        <!--PAGINATION SECTION-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-->
        <v-pagination
            :length="pagesCount"
            @input="paginationDebounce(500)"
            class="pagination-bar base-background"
            total-visible="7"
            v-model="pageNo"
            v-show="pagesCount > 1"
        ></v-pagination>
    </v-container>
</template>

<script>
import MedikreditClaimForm from "../components/forms/MedikreditClaimForm";
import dateToString from "../helpers/dateToString";
import uuid4 from "../helpers/uuid4";

export default {
    name: "MedikreditClaims",
    props: [],
    data: function() {
        return {
            //main data
            medikreditclaimsReducedView: null,
            //pagination
            pageNo: 1,
            pageSize: 6,
            pagesCount: 0,
            searchString: "",
            orderBy: "",
            sortOrder: 0,
            paginationTimeout: null,
            requestId: uuid4(),
            totalMatches: null,
            filenameRegex: /[^\\]*$/,

            //form data
            medikreditclaimFormVisible: false,
            medikreditclaimFormId: null
        };
    },
    created: async function() {
        this.getMedikreditClaims();
    },
    mounted: function() {},
    components: {
        MedikreditClaimForm
        //
    },
    computed: {
        //
    },
    methods: {
        openAccountInNewWindow(accountId) {
            let routeData = this.$router.resolve({
                name: "Accounts",
                params: {
                    accountId: accountId
                }
            });
            window.open(routeData.href, "_blank");
        },
        async getMedikreditClaims() {
            var requestId = (this.requestId = uuid4());

            var urlParameters = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                searchString: this.searchString,
                orderBy: this.orderBy,
                sortOrder: this.sortOrder
            };

            var medikreditclaimsResponse = await this.$store.dispatch(
                "medikreditclaims/getreducedview",
                {
                    id: null,
                    urlParameters,
                    requestId: requestId
                }
            );

            if (this.requestId == medikreditclaimsResponse.requestId) {
                //medikreditclaimsResponse.data.page.forEach(x =>this.medikreditclaimApplyDisciplineName(x.entity));
                this.medikreditclaimsReducedView =
                    medikreditclaimsResponse.data.page;
                this.totalMatches = medikreditclaimsResponse.data.total;
                this.pagesCount = Math.ceil(
                    medikreditclaimsResponse.data.total / this.pageSize
                );
            }
        },
        paginationDebounce(debounceTime) {
            if (this.medikreditclaimsReducedView !== null)
                this.medikreditclaimsReducedView = null;
            clearTimeout(this.paginationTimeout);
            this.paginationTimeout = setTimeout(
                this.getMedikreditClaims,
                debounceTime
            );
        },
        loadMedikreditClaimForm(medikreditclaim) {
            this.medikreditclaimFormId = medikreditclaim.id;
            this.medikreditclaimFormVisible = true;
        },
        closeMedikreditClaimForm() {
            this.medikreditclaimFormVisible = false;
            this.medikreditclaimFormId = null;
        },
        updateMedikreditClaim() {
            this.paginationDebounce(0);
        },
        deleteMedikreditClaim() {
            this.paginationDebounce(0);
        },
        dateToString(date) {
            return dateToString(date ? new Date(date) : null);
        }
    }
};
</script>

<style lang="stylus" scoped>
.incident-card {
    /* background: linear-gradient(45deg, rgba(127,127,127,0.1), transparent,rgba(127,127,127,0.1)) */
    .center-content {
        background-color: rgba(127, 127, 127, 0.15);
    }
}

.theme--dark {
    .patient-panel {
        .v-card {
            background-color: rgba(127, 127, 127, 0.1);
        }
    }
}

.pagination-bar {
    // position: fixed;
    bottom: 0;
    margin: auto;
    left: 0;
    right: 0;
    padding-bottom: 0.1rem;
    padding-top: 0.1rem;
    /*
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border:1px solid rgba(127, 127, 127, 0.2)
    */
}

.theme--light {
    .base-background {
        background: #FFFFFF;
    }
}

.theme--dark {
    .base-background {
        background: #121212;
    }
}
</style>
